<template>
    <div>
      <!--
    <table width='100%' class='table' v-if='data.length'>
      <tr>
        <th width='15%' class='colTitle'>{{ $t("Env") }}</th>
        <th width='40%' class='colTitle'>{{ $t("Client") }}</th>
        <th width='15%' class='colTitle'>{{ $t("Equity") }}</th>
        <th width='15%' class='colTitle'>{{ $t("Margin Level") }}</th>
      </tr>
      <tr v-for='(cli, index) in data' :key='index' class='lu-click' @dblclick='getDetail(cli.accountName)'>
        <td width='15%' class='rowTitle'>{{ cli.brokerName }}</td>
        <td width='40%' class='rowTitle'>{{ cli.accountName }}</td>
        <td width='15%' class='rowData' :class='cli.AccountEquity >= 0  ? "positive" : "negative"'>{{ cli.AccountEquity | formatAmount }}</td>
        <td width='15%' class='rowData'>{{ cli.usedMarginPerc | formatPercent }}</td>
      </tr>
    </table>
    -->
    <el-table
      class='riskTable'
      :cell-class-name = "() => 'lu-click'"
      :data="data"
      :height="parentPanelHeight"
      fit
      style="width: 100%;"
      :row-class-name="tableRowClassName"
      @row-dblclick='row => getDetail(row.brokerName,row.accountNumber,row.accountName)'
    >
      <el-table-column :label="$t('Env')" sortable prop='brokerName' align="left" />
      <el-table-column :label="$t('Client')" sortable prop='accountName' align="left"  min-width='200'  />
      <el-table-column :label="$t('Account')" sortable prop='accountNumber' align="left" />
      <el-table-column :label="$t('Equity')" sortable :sort-method='(a,b) => sortFloat(a,b,"AccountEquity")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.AccountEquity >= 0  ? "positive" : "negative"'>{{ scope.row.AccountEquity | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Margin Level')" sortable :sort-method='(a,b) => sortFloat(a,b,"usedMarginPerc")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right'>{{ scope.row.usedMarginPerc | formatPercent }}</div>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import utils from '@/utils/formatNumber'
import monitoringMixin from './mixins'

export default {
  name: 'MarginCallArray',
  props: [ 'data', 'parentPanel', 'panel' ],
  mixins: [ monitoringMixin ],
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value, 2, 3)
    },
    formatPercent: function (value) {
      return value + ' %'
    }
  },
  methods: {
    getDetail: function (brokerName, accountNumber, label) {
      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': 'platform', 'paramValue': brokerName},
        {'paramName': 'accountNumber', 'paramValue': accountNumber},
        {'paramName': 'account', 'paramValue': label}
      ]
      this.$emit('getDetail', {title: this.panel.options.title, type: 'account', value: label, params: params, show: true})
    }
  }
}
</script>

<style scoped>
</style>